/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import AppNavStep from '../../../components/appNav/AppNavStep';
import MfaCodeEntry from '../../../contentViews/MfaCodeEntry';
import PaddedContent from '../../../components/PaddedContent';
import { ScrollAwareFixedHeader } from '../../../components/ScrollAware';

class ChangePasswordWithMfa extends React.Component {

  constructor(props) {
    super(props);

    this.goBack = this.goBack.bind(this);
    this.submitPasswordChange = this.submitPasswordChange.bind(this);
  }

  goBack() {
    this.props.clearPassword();
    this.props.goBack();
  }

  submitPasswordChange() {
    this.props.submitMfaCode((apiError) => {
      if (!apiError) {
        this.props.finishPasswordChange();
      }
    });
  }

  render() {
    return (
      <div>
        <ScrollAwareFixedHeader colorThemeName="profile">
          <AppNavStep
            title="settingsChangePwd.title.text"
            submitDisabled={this.props.submitDisabled}
            submit={this.submitPasswordChange}
            cancel={this.goBack}
            color="white"
          />
        </ScrollAwareFixedHeader>

        <div>
          <PaddedContent>
            <MfaCodeEntry
              isWaitingForMfa
              cancelMfaRoute={this.props.cancelMfaRoute}
              token={this.props.token}
              errorMessage=""
              mfaCode={this.props.mfaCode}
              mobileNumber=""
              submitMfaCode={this.submitPasswordChange}
              onChangeMfaCode={this.props.onChangeMfaCode}
            />
          </PaddedContent>
        </div>
      </div>
    );
  }
}
ChangePasswordWithMfa.propTypes = {
  isWaitingForMfa: PropTypes.bool,
  mfaCode: PropTypes.string,
  token: PropTypes.string,
  cancelMfaRoute: PropTypes.string,
  submitMfaCode: PropTypes.func,
  onChangeMfaCode: PropTypes.func,
  clearPassword: PropTypes.func,
  finishPasswordChange: PropTypes.func,
  goBack: PropTypes.func,
  submitDisabled: PropTypes.bool,
};

export default ChangePasswordWithMfa;
